import { render, staticRenderFns } from "./table-task-body.vue?vue&type=template&id=9545ee34&"
import script from "./table-task-body.vue?vue&type=script&lang=js&"
export * from "./table-task-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports